import React, { useEffect, useState } from 'react';
import { NoticeItem } from '../components/announcement/NoticeItem';
import { CmmnPaging } from '../components/common/CmmnPaging';
import { NoticeCate } from '../components/announcement/NoticeCate';
import { useAnnouncementListStore } from 'store/useAnnouncementListStore';
import { usePagination } from 'hooks/usePagination';
import { useCategoryNavigation } from 'hooks/useCategoryNavigation';

import './NoticeScreen.scss';

export const NoticeScreen = () => {
    const [searchText, setSearchText] = useState('');

    const announcementList = useAnnouncementListStore(
        (state) => state.announcementList
    );
    const pagination = useAnnouncementListStore((state) => state.pagination);

    const { fetchAnnouncementList } = useAnnouncementListStore();
    const { cate, changeCategory } = useCategoryNavigation();
    const { page, totalCount, pageSize, goToPage } = usePagination(pagination);

    const fetchAnnouncementData = async (
        currentPage: number,
        category: string,
        searchText: string
    ) => {
        await fetchAnnouncementList(currentPage, category, searchText);
    };

    useEffect(() => {
        fetchAnnouncementData(page, cate, searchText);
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        fetchAnnouncementData(page, cate, searchText);
    }, [cate, page]);

    return (
        <>
            <NoticeCate callback={changeCategory} />
            <div className='notice-items-container'>
                {announcementList?.map((item, index) => (
                    <NoticeItem
                        key={index}
                        item={{
                            ...item,
                            n_list_summary: item.n_list_summary ?? '',
                            n_title_summary: item.n_title_summary ?? '',
                        }}
                    />
                ))}
            </div>
            {announcementList ? (
                <CmmnPaging
                    currentPage={page}
                    totalCount={totalCount}
                    pageSize={pageSize}
                    clickPage={(page) => {
                        goToPage(page);
                        fetchAnnouncementData(page, cate, searchText);
                    }}
                    clickSearch={(text) => {
                        setSearchText(text);
                        fetchAnnouncementData(page, cate, searchText);
                    }}
                />
            ) : null}
        </>
    );
};
